<template>
  <div
    class="pricing"
    :class="{
      hidden: aplicacion.view.Live == '3d',
      noButton: noButton,
      hayMontaje: aplicacion.montajeExists() && montaje.valor == 0,
    }"
  >
    <div class="pricing__container">
      <div class="pricing__container__title" v-if="privada != 'true'">
        {{
          aplicacion.languageSel == "es"
            ? "Precio desde:"
            : aplicacion.languageSel == "en"
            ? "Price from:"
            : aplicacion.languageSel == "fr"
            ? "Prix à partir de"
            : aplicacion.languageSel == "de"
            ? "Preis ab:"
            : aplicacion.languageSel == "it"
            ? "Prezzo da:"
            : "Preço a partir de:"
        }}
      </div>
      <div class="pricing__container__value">
        <img
          src="@/assets/Images/Global/Loader.svg"
          alt=""
          class="pricing__container__value__loader"
          :class="{
            visible: Loading,
          }"
        />
        <div
          class="pricing__container__value__price"
          :class="{
            visible: !Loading && !Error,
          }"
        >
          <div class="pricing__container__value__price__top">
            <span>{{ Price.precio }}</span>
            <span>{{ Price.moneda }}</span>
            <span style="font-size: 18px; margin-left: 8px; font-weight: 600">
              PVPR
            </span>
          </div>
          <div
            v-if="aplicacion.montajeExists()"
            class="pricing__container__value__price__bottom"
            :class="{
              visible: !Loading && !Error,
              noMontaje: montaje.valor == 0,
            }"
          >
            <span>+ {{ montaje.precioTarifa }}</span>
            <span>{{ Price.moneda }}</span>
            <span>{{ " - " + montaje.texto }}</span>
          </div>
        </div>
        <p
          class="pricing__container__value__error"
          :class="{
            visible: !Loading && Error,
          }"
          :style="
            aplicacion.tipo != 'configurable'
              ? { fontSize: '12px', marginTop: '-15px' }
              : {}
          "
        >
          {{ ErrorMessage }}
        </p>
      </div>
      <div class="pricing__container__info">
        <p class="pricing__container__info__item">
          *
          {{
            aplicacion.languageSel == "es"
              ? "Impuestos incluidos."
              : aplicacion.languageSel == "en"
              ? "Taxes included."
              : aplicacion.languageSel == "fr"
              ? "Taxes incluses."
              : aplicacion.languageSel == "de"
              ? "Steuern inbegriffen."
              : aplicacion.languageSel == "it"
              ? "Tasse incluse."
              : "Impostos incluídos."
          }}
        </p>
        <p class="pricing__container__info__item">
          *
          {{
            aplicacion.languageSel == "es"
              ? "Precio válido para peninsula."
              : aplicacion.languageSel == "en"
              ? "Price valid for the peninsula."
              : aplicacion.languageSel == "fr"
              ? "Prix valable pour la péninsule."
              : aplicacion.languageSel == "de"
              ? "Preis gültig für die Halbinsel."
              : aplicacion.languageSel == "it"
              ? "Prezzo valido per la penisola."
              : "Preço válido para a península."
          }}
        </p>
      </div>
      <div class="pricing__container__type">
        <div
          class="pricing__container__type__producto"
          :class="{
            hidden: aplicacion.tipo == 'configurable',
          }"
        >
          <div class="pricing__container__type__producto__line">Producto</div>
          <div class="pricing__container__type__producto__line">STANDARD</div>
        </div>
        <div
          class="pricing__container__type__producto"
          :class="{
            hidden: aplicacion.tipo == 'estandar',
          }"
        >
          <div class="pricing__container__type__producto__line">
            Producto a medida
          </div>
          <div class="pricing__container__type__producto__line">
            PERSONALIZADO
          </div>
        </div>
        <div
          class="pricing__container__type__envio"
          :class="{
            error: Error,
          }"
        >
          <img
            src="@/assets/Images/Global/Camion.svg"
            alt=""
            class="pricing__container__type__envio__image"
          />
          <div
            class="pricing__container__type__envio__time"
            :class="{
              loading: LoadingEnvio,
            }"
          >
            <img
              src="@/assets/Images/Global/Loader.svg"
              alt=""
              class="pricing__container__type__envio__time__loader"
            />
            <p class="pricing__container__type__envio__time__text">
              {{ Message }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <button
      class="pricing__buy"
      :class="{
        hidden: Loading || Error || bloquearpedidos,
      }"
      @click="$root.$emit('SetDondeComprar')"
    >
      {{
        privada == "true"
          ? aplicacion.languageSel == "es"
            ? "Añadir al pedido"
            : aplicacion.languageSel == "en"
            ? "Add to order"
            : aplicacion.languageSel == "fr"
            ? "Ajouter à la commande"
            : aplicacion.languageSel == "de"
            ? "Zur Bestellung hinzufügen"
            : aplicacion.languageSel == "it"
            ? "Aggiungi all'ordine"
            : ""
          : aplicacion.languageSel == "es"
          ? "¿ Dónde Comprar ?"
          : aplicacion.languageSel == "en"
          ? "Where to buy ?"
          : aplicacion.languageSel == "fr"
          ? "Où acheter ?"
          : aplicacion.languageSel == "de"
          ? "Wo zu kaufen ?"
          : aplicacion.languageSel == "it"
          ? "Dove comprare ?"
          : ""
      }}
    </button>
    <div
      class="pricing__envio"
      :class="{
        loading: LoadingEnvio,
        error: Error,
      }"
    >
      <img
        src="@/assets/Images/Global/Camion.svg"
        alt=""
        class="pricing__envio__image"
      />
      <div class="pricing__envio__time">
        <img
          src="@/assets/Images/Global/Loader.svg"
          alt=""
          class="pricing__envio__time__loader"
        />
        <p class="pricing__envio__time__text">{{ Message }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Pricing",
  data() {
    return {
      Price: Object,
      Error: Boolean,
      ErrorMessage: String,
      Loading: false,
      LoadingEnvio: false,
      Message: "",
      lastPriceId: 0,
    };
  },
  props: {
    bloquearpedidos: Boolean,
    noButton: {
      type: Boolean,
      default: false,
    },
    aplicacion: Object,
    sideSel: Object,
    token: String,
    privada: String,
  },
  computed: {
    montaje() {
      var grupo = this.aplicacion.coleccionSel.sideSel.Live.GetGrupo("MONTAJE");

      if (grupo) {
        const el = grupo.campos[0].precios[grupo.campos[0].acabadoSel.cod];
        const obj = {
          valor: el.valor,
          importe: el.importe,
          precioTarifa: el.precioTarifa,
          texto: this.getTexto(this.aplicacion.languageSel, el.valor),
        };
        this.$emit("montaje", obj);
        return obj;
      }
    },
  },
  mounted() {
    this.SetPrice();
  },
  watch: {
    "aplicacion.coleccionSel.sideSel.Live.perfil": {
      handler(newValue, oldValue) {
        this.SetPrice();
      },
      deep: true,
    },
    "aplicacion.tipo": {
      handler(newValue, oldValue) {
        this.LoadingEnvio = true;
      },
      deep: true,
    },
  },
  methods: {
    getTexto(lang, cod) {
      let text = "";

      switch (cod) {
        case 1:
          switch (lang) {
            case "es":
              text = "Solo montaje";
              break;
            case "en":
              text = "Assembly only";
              break;
            case "fr":
              text = "Montage seulement";
              break;
            case "de":
              text = "Nur Montage";
              break;
            case "it":
              text = "Solo montaggio";
              break;
            default:
              text = "Solo montaje";
              break;
          }
          break;

        case 2:
          switch (lang) {
            case "es":
              text = "Medición y montaje";
              break;
            case "en":
              text = "Measurement and assembly";
              break;
            case "fr":
              text = "Mesure et montage";
              break;
            case "de":
              text = "Messung und Montage";
              break;
            case "it":
              text = "Misurazione e montaggio";
              break;
            default:
              text = "Medición y montaje";
              break;
          }
          break;

        case 3:
          switch (lang) {
            case "es":
              text = "Medición, montaje y desmontaje";
              break;
            case "en":
              text = "Measurement, assembly, and disassembly";
              break;
            case "fr":
              text = "Mesure, montage et démontage";
              break;
            case "de":
              text = "Messung, Montage und Demontage";
              break;
            case "it":
              text = "Misurazione, montaggio e smontaggio";
              break;
            default:
              text = "Medición, montaje y desmontaje";
              break;
          }
          break;

        default:
          text = "";
          break;
      }

      return text;
    },
    ResolveCondicion(id, Condicion) {
      var Status = true;

      if (Condicion != "" && Condicion != undefined) {
        try {
          var perfil = this.aplicacion.coleccionSel.sideSel.Live.perfil;
          Status = eval(Condicion);
        } catch (error) {
          //console.log(error);
          //console.log(id);
          //console.log(Condicion);
        }
      }

      return Status;
    },
    SetPrice() {
      this.Loading = true;
      if (this.aplicacion.tipo == "configurable") {
        setTimeout(() => {
          this.SetPriceConfigurable();
        }, 350);
      } else {
        this.LoadingEnvio = true;
        setTimeout(() => {
          this.SetPriceEstandar();
        }, 350);
      }
    },
    SetPriceConfigurable() {
      //console.log("SetPriceConfigurable()");
      this.Message =
        this.aplicacion.languageSel == "es"
          ? "Envío en 7 días (laborables)"
          : this.aplicacion.languageSel == "en"
          ? "Shipping in 7 (working) days"
          : this.aplicacion.languageSel == "fr"
          ? "Livraison en 7 jours ouvrables"
          : this.aplicacion.languageSel == "de"
          ? "Versand in 7 Werktagen"
          : this.aplicacion.languageSel == "it"
          ? "Spedizione in 7 giorni lavorativi"
          : "Envio em 7 dias úteis";
      var Price = new Object();
      Price.caracteristicas = new Array();
      Price.codigo = this.aplicacion.coleccionSel.cod.toUpperCase();
      Price.posiciones = new Array();
      var Posicion = new Object();
      Posicion.cantidad = 1;
      Posicion.material = this.aplicacion.coleccionSel.cod.toUpperCase();
      Posicion.posLm = "";
      Posicion.posicion = 10;
      Price.posiciones.push(Posicion);

      let perfil = this.aplicacion.coleccionSel.sideSel.Live.perfil;
      //console.log("perfil Antes", perfil);
      this.aplicacion.coleccionSel.sideSel.Live.grupos.forEach((Grupo) => {
        Grupo.campos.forEach((CaracteristicaEl) => {
          if (
            this.ResolveCondicion(
              CaracteristicaEl.cod,
              CaracteristicaEl.condicion
            ) &&
            CaracteristicaEl.cod != "SUELO" &&
            CaracteristicaEl.cod != "PARED"
          ) {
            var Caracteristica = new Object();
            Caracteristica.id = CaracteristicaEl.id;
            // El COLOR_PERFIL se vuelve a transformar en COLOR_PERFIL_ST
            if (CaracteristicaEl.cod == "COLOR_PERFIL_ST") {
              let cambio =
                this.aplicacion.datosConfigurable.caracteristicas.filter(
                  (caracteristica) => caracteristica.codigo == "COLOR_PERFIL"
                );
              if (cambio.length == 1) {
                Caracteristica.name = "COLOR_PERFIL";
              } else {
                Caracteristica.name = "COLOR_PERFIL_ST";
              }
              //console.log(Caracteristica.name);
            } else if (CaracteristicaEl.cod == "POMO_ST") {
              let cambio =
                this.aplicacion.datosConfigurable.caracteristicas.filter(
                  (caracteristica) => caracteristica.codigo == "POMO"
                );
              if (cambio.length == 1) {
                Caracteristica.name = "POMO";
              } else {
                Caracteristica.name = "POMO_ST";
              }
            } else {
              Caracteristica.name = CaracteristicaEl.cod;
            }

            Caracteristica.value =
              CaracteristicaEl.tipo == "input"
                ? CaracteristicaEl.value
                : CaracteristicaEl.acabadoSel.cod;
            Caracteristica.posicion = 10;
            Caracteristica.human = {
              label: CaracteristicaEl.GetLiteral(this.aplicacion.languageSel),
              value:
                CaracteristicaEl.tipo == "input"
                  ? CaracteristicaEl.value
                  : CaracteristicaEl.acabadoSel.GetLiteral(
                      this.aplicacion.languageSel
                    ),
            };
            Caracteristica.error = false;

            let carCod = CaracteristicaEl.cod.toLowerCase();
            //console.log(
            //   carCod,
            //   carCod in perfil
            // );

            Price.caracteristicas.push(Caracteristica);
          }
        });
      });

      //console.log("perfil Después", perfil);

      // Se genera un id para la petición y se guarda el último. Si una petición es lenta y otra
      // se adelanta, la petición lenta se desecha, para no poner un precio erróneo
      Price.id = Math.floor(Math.random() * 1000000000);
      this.lastPriceId = Price.id;
      //console.table(Price.caracteristicas);
      //console.log("Petición", Price.id);
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: "https://clients.docciagroup.com/api/renders/precio-configurable",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.token,
        },
        data: Price,
      };

      // let diferencia = this.findDifferences(p1, p2);
      // //console.log(diferencia);
      axios
        .request(config)
        .then((response) => {
          console.log(response);
          // Sólo debe actualizar la última petición, si una petición tarda mucho y otra
          // se adelanta, la petición lenta se desecha, para no poner un precio erróneo
          if (this.lastPriceId != Price.id) {
            return;
          }

          this.Error = false;
          //console.log(response.data.precio);
          if (response.data.precio == 0) {
            this.Error = true;
            const errorMessages = {
              configurable: {
                es: "¡Revise configurador!",
                en: "Check configurator!",
                fr: "Vérifiez le configurateur!",
                de: "Konfigurator überprüfen!",
                it: "Controlla il configuratore!",
                default: "Confira o configurador!",
              },
              default: {
                es: "¡Revise configuración!\nCombinación de valores no disponibles",
                en: "Check configuration:\nCombination of values not available",
                fr: "Vérifiez la configuration :\nCombinaison de valeurs non disponibles",
                de: "Überprüfen Sie die Konfiguration:\nKombination von Werten nicht verfügbar",
                it: "Controlla la configurazione:\nCombinazione di valori non disponibili",
                default:
                  "Confira a configuração:\nCombinação de valores não disponíveis",
              },
            };

            const tipoKey =
              aplicacion.tipo === "configurable" ? "configurable" : "default";
            this.ErrorMessage =
              errorMessages[tipoKey][aplicacion.languageSel] ||
              errorMessages[tipoKey].default;
          } else if (response.data.error) {
            this.Error = true;
            this.ErrorMessage = response.data.msgError;
          }
          this.Price = {
            precio: Number.isInteger(response.data.precio)
              ? response.data.precio.toString()
              : response.data.precio.toFixed(2),
            precioFijo: response.data.precioFijo,
            moneda: response.data.moneda,
          };
          this.Price.moneda = "€";
          this.Loading = false;
          this.LoadingEnvio = false;

          Price.configurable = true;
          Price.material = this.aplicacion.datosConfigurable.material;
          Price.moneda = "EUR";
          Price.precio = Number.isInteger(response.data.precio)
            ? response.data.precio.toString()
            : response.data.precio.toFixed(2);
          // Actualiza el objeto aplicacion
          this.aplicacion.coleccionSel.sideSel.Live.priceObj = Price;
        })
        .catch((error) => {
          //console.log(error);
        });
    },
    SetPriceEstandar() {
      var codigo = this.aplicacion.GetCodigoEstandar();

      if (codigo == "ERROR") {
        this.Error = true;
        this.Loading = false;
        return;
      }

      let config = {
        method: "get",
        maxBodyLength: Infinity,
        url:
          "https://clients.docciagroup.com/api/renders/precio-estandar?codigo=" +
          codigo,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.token,
        },
      };
      axios
        .request(config)
        .then((response) => {
          console.log(response);
          this.aplicacion.languageSel == "es"
            ? (this.Message =
                response.data.stock == 0
                  ? "Envío en 4-5 días (laborables)"
                  : "Envío en 24-48 horas")
            : this.aplicacion.languageSel == "en"
            ? (this.Message =
                response.data.stock == 0
                  ? "Shipping in 4-5 (working) days"
                  : "Shipping in 24-48 hours")
            : this.aplicacion.languageSel == "fr"
            ? (this.Message =
                response.data.stock == 0
                  ? "Livraison en 4-5 jours ouvrables"
                  : "Livraison en 24-48 heures")
            : this.aplicacion.languageSel == "de"
            ? (this.Message =
                response.data.stock == 0
                  ? "Versand in 4-5 Werktagen"
                  : "Versand in 24-48 Stunden")
            : this.aplicacion.languageSel == "it"
            ? (this.Message =
                response.data.stock == 0
                  ? "Spedizione in 4-5 giorni lavorativi"
                  : "Spedizione in 24-48 ore")
            : (this.Message =
                response.data.stock == 0
                  ? "Envio em 4-5 dias úteis"
                  : "Envio em 24-48 horas");
          this.Error = false;
          //console.log(response.data.precio);
          if (response.data.precio == 0) {
            this.Error = true;
            const errorMessages = {
              configurable: {
                es: "¡Revise configurador!",
                en: "Check configurator!",
                fr: "Vérifiez le configurateur!",
                de: "Konfigurator überprüfen!",
                it: "Controlla il configuratore!",
                default: "Confira o configurador!",
              },
              default: {
                es: "¡Revise configuración!\nCombinación de valores no disponibles",
                en: "Check configuration:\nCombination of values not available",
                fr: "Vérifiez la configuration :\nCombinaison de valeurs non disponibles",
                de: "Überprüfen Sie die Konfiguration:\nKombination von Werten nicht verfügbar",
                it: "Controlla la configurazione:\nCombinazione di valori non disponibili",
                default:
                  "Confira a configuração:\nCombinação de valores não disponíveis",
              },
            };

            const tipoKey =
              aplicacion.tipo === "configurable" ? "configurable" : "default";
            this.ErrorMessage =
              errorMessages[tipoKey][aplicacion.languageSel] ||
              errorMessages[tipoKey].default;
          } else if (response.data.error) {
            this.Error = true;
            this.ErrorMessage = response.data.msgError;
          }
          this.Price = {
            precio: Number.isInteger(response.data.precio)
              ? response.data.precio.toString()
              : response.data.precio.toFixed(2),
            precioFijo: response.data.precioFijo,
            moneda: response.data.moneda,
          };
          this.Price.moneda = "€";

          var side = this.aplicacion.coleccionSel.sideSel.Live;
          var caracteristicas = this.aplicacion.datosEstandar.caracteristicas;
          var campo;
          var priceObj = side.priceObj;

          // Actualiza el objeto del precio del side
          priceObj.precio = Number.isInteger(response.data.precio)
            ? response.data.precio.toString()
            : response.data.precio.toFixed(2);
          priceObj.id = response.data.id;
          priceObj.moneda = response.data.moneda;
          priceObj.codigo = codigo;
          priceObj.configurable = false;
          priceObj.caracteristicas = [];

          for (const clave in caracteristicas) {
            if (caracteristicas.hasOwnProperty(clave)) {
              campo = side.GetCampo(clave);
              priceObj.caracteristicas.push({
                human: {
                  label: clave,
                  value: campo.acabadoSel.GetLiteral(
                    this.aplicacion.languageSel
                  ),
                },
              });
            }
          }
          // Actualiza objeto price del side
          side.priceObj = priceObj;

          this.Loading = false;
          this.LoadingEnvio = false;
        })
        .catch((error) => {
          this.Error = true;
          this.Loading = false;
          this.LoadingEnvio = false;
        });
    },
    findDifferences(json1, json2) {
      const json1Map = new Map();
      const json2Map = new Map();

      // Convertir json1 y json2 en mapas para una búsqueda rápida por id
      json1.forEach((item) => json1Map.set(item.id, item));
      json2.forEach((item) => json2Map.set(item.id, item));

      const differences = [];

      // Función para comparar dos objetos y encontrar diferencias
      function compareObjects(obj1, obj2) {
        const diffs = {};
        const keys = new Set([...Object.keys(obj1), ...Object.keys(obj2)]);

        keys.forEach((key) => {
          if (obj1[key] !== obj2[key]) {
            diffs[key] = { value1: obj1[key], value2: obj2[key] };
          }
        });

        return Object.keys(diffs).length > 0 ? diffs : null;
      }

      // Comparar los elementos de json1 con json2
      json1Map.forEach((item1, id) => {
        const item2 = json2Map.get(id);
        if (item2) {
          const diffs = compareObjects(item1, item2);
          if (diffs) {
            differences.push({ id, differences: diffs });
          }
          json2Map.delete(id); // Eliminar el id de json2Map una vez comparado
        } else {
          differences.push({
            id,
            differences: { value1: item1, value2: null },
          });
        }
      });

      // Los elementos restantes en json2Map no están en json1
      json2Map.forEach((item2, id) => {
        differences.push({ id, differences: { value1: null, value2: item2 } });
      });

      return differences;
    },
  },
};
</script>

<style lang="scss" scoped>
.pricing {
  opacity: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  align-items: center;
  position: absolute;
  bottom: -235px;
  left: -160px;
  width: 465px;
  height: 465px;
  border-radius: 100%;
  background-color: rgba(255, 255, 255, 0.65);
  z-index: 10000000;
  -webkit-transition: opacity 0.35s ease-in-out,
    background-color 0.35s ease-in-out;
  -moz-transition: opacity 0.35s ease-in-out, background-color 0.35s ease-in-out;
  -ms-transition: opacity 0.35s ease-in-out, background-color 0.35s ease-in-out;
  -o-transition: opacity 0.35s ease-in-out, background-color 0.35s ease-in-out;
  transition: opacity 0.35s ease-in-out, background-color 0.35s ease-in-out;

  &__container {
    position: absolute;
    left: 195px;
    bottom: 285px;
    color: black;
    -webkit-transition: color 0.35s ease-in-out;
    -moz-transition: color 0.35s ease-in-out;
    -ms-transition: color 0.35s ease-in-out;
    -o-transition: color 0.35s ease-in-out;
    transition: color 0.35s ease-in-out;

    &__title {
      font-size: 14px;
      line-height: 14px;
      margin-bottom: 7px;
    }

    &__value {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      position: relative;

      &__loader {
        opacity: 0;
        margin-left: -10px;
        pointer-events: none;
        position: absolute;
        height: 35px;
        object-fit: cover;
        filter: invert(0%);
        -webkit-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
        -moz-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
        -ms-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
        -o-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
        transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;

        &.visible {
          opacity: 1;
          pointer-events: visible;
          -webkit-transition: opacity 0.35s ease-in-out,
            filter 0.35s ease-in-out;
          -moz-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
          -ms-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
          -o-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
          transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
        }
      }

      &__price {
        opacity: 0;
        pointer-events: none;
        -webkit-transition: opacity 0.35s ease-in-out;
        -moz-transition: opacity 0.35s ease-in-out;
        -ms-transition: opacity 0.35s ease-in-out;
        -o-transition: opacity 0.35s ease-in-out;
        transition: opacity 0.35s ease-in-out;

        &__top {
          font-size: 35px;
          line-height: 35px;
          letter-spacing: -1px;
        }

        &__bottom {
          opacity: 1;
          margin-top: 0px;
          font-size: 18px;
          line-height: 18px;
          letter-spacing: -1px;
          max-width: 200px;
          font-weight: 600;
          -webkit-transition: opacity 0.35s ease-in-out,
            margin-top 0.35s ease-in-out;
          -moz-transition: opacity 0.35s ease-in-out,
            margin-top 0.35s ease-in-out;
          -ms-transition: opacity 0.35s ease-in-out,
            margin-top 0.35s ease-in-out;
          -o-transition: opacity 0.35s ease-in-out, margin-top 0.35s ease-in-out;
          transition: opacity 0.35s ease-in-out, margin-top 0.35s ease-in-out;

          &.noMontaje {
            opacity: 0;
            margin-top: -15px;
            -webkit-transition: opacity 0.35s ease-in-out,
              margin-top 0.35s ease-in-out;
            -moz-transition: opacity 0.35s ease-in-out,
              margin-top 0.35s ease-in-out;
            -ms-transition: opacity 0.35s ease-in-out,
              margin-top 0.35s ease-in-out;
            -o-transition: opacity 0.35s ease-in-out,
              margin-top 0.35s ease-in-out;
            transition: opacity 0.35s ease-in-out, margin-top 0.35s ease-in-out;
          }
        }

        &.visible {
          opacity: 1;
          pointer-events: visible;
          -webkit-transition: opacity 0.35s ease-in-out;
          -moz-transition: opacity 0.35s ease-in-out;
          -ms-transition: opacity 0.35s ease-in-out;
          -o-transition: opacity 0.35s ease-in-out;
          transition: opacity 0.35s ease-in-out;
        }
      }

      &__error {
        opacity: 0;
        color: #cc0000;
        pointer-events: none;
        position: absolute;
        font-weight: 600;
        font-size: 16px;
        line-height: 16px;
        -webkit-transition: opacity 0.35s ease-in-out;
        -moz-transition: opacity 0.35s ease-in-out;
        -ms-transition: opacity 0.35s ease-in-out;
        -o-transition: opacity 0.35s ease-in-out;
        transition: opacity 0.35s ease-in-out;

        @media screen and (max-width: 950px) {
          width: 190px;
        }

        &.visible {
          opacity: 1;
          pointer-events: visible;
          -webkit-transition: opacity 0.35s ease-in-out;
          -moz-transition: opacity 0.35s ease-in-out;
          -ms-transition: opacity 0.35s ease-in-out;
          -o-transition: opacity 0.35s ease-in-out;
          transition: opacity 0.35s ease-in-out;
        }

        &2 {
          display: none;
        }
      }
    }

    &__info {
      margin-top: 10px;

      &__item {
        font-size: 11px;
        line-height: 11px;

        &:last-child {
          margin-top: 3px;
        }
      }
    }

    &__type {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      margin-top: 5px;

      &__producto {
        opacity: 1;
        position: absolute;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        height: 34px;
        -webkit-transition: opacity 0.35s ease-in-out;
        -moz-transition: opacity 0.35s ease-in-out;
        -ms-transition: opacity 0.35s ease-in-out;
        -o-transition: opacity 0.35s ease-in-out;
        transition: opacity 0.35s ease-in-out;

        &__line {
          font-size: 15px;
          line-height: 17px;

          &:last-child {
            font-weight: 600;
          }
        }

        &.hidden {
          opacity: 0;
          -webkit-transition: opacity 0.35s ease-in-out;
          -moz-transition: opacity 0.35s ease-in-out;
          -ms-transition: opacity 0.35s ease-in-out;
          -o-transition: opacity 0.35s ease-in-out;
          transition: opacity 0.35s ease-in-out;
        }

        display: none;
      }

      &__envio {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        align-content: center;

        &__image {
          opacity: 1;
          height: 30px;
          margin-right: 10px;
          -webkit-transition: opacity 0.35s ease-in-out;
          -moz-transition: opacity 0.35s ease-in-out;
          -ms-transition: opacity 0.35s ease-in-out;
          -o-transition: opacity 0.35s ease-in-out;
          transition: opacity 0.35s ease-in-out;
        }

        &__time {
          margin-left: 0px;
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          align-content: center;
          position: relative;
          -webkit-transition: margin-left 0.35s ease-in-out;
          -moz-transition: margin-left 0.35s ease-in-out;
          -ms-transition: margin-left 0.35s ease-in-out;
          -o-transition: margin-left 0.35s ease-in-out;
          transition: margin-left 0.35s ease-in-out;

          &__loader {
            filter: invert(0%);
            margin-left: -10px;
            opacity: 0;
            position: absolute;
            height: 35px;
            -webkit-transition: opacity 0.35s ease-in-out,
              filter 0.35s ease-in-out;
            -moz-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
            -ms-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
            -o-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
            transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
          }

          &__text {
            opacity: 1;
            position: absolute;
            white-space: nowrap;
            font-size: 13px;
            line-height: 13px;
            -webkit-transition: opacity 0.35s ease-in-out;
            -moz-transition: opacity 0.35s ease-in-out;
            -ms-transition: opacity 0.35s ease-in-out;
            -o-transition: opacity 0.35s ease-in-out;
            transition: opacity 0.35s ease-in-out;
          }

          &.loading {
            & .pricing__container__type__envio__time {
              &__loader {
                opacity: 1;
                position: absolute;
                -webkit-transition: opacity 0.35s ease-in-out,
                  filter 0.35s ease-in-out;
                -moz-transition: opacity 0.35s ease-in-out,
                  filter 0.35s ease-in-out;
                -ms-transition: opacity 0.35s ease-in-out,
                  filter 0.35s ease-in-out;
                -o-transition: opacity 0.35s ease-in-out,
                  filter 0.35s ease-in-out;
                transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
              }

              &__text {
                opacity: 0;
                position: absolute;
                -webkit-transition: opacity 0.35s ease-in-out;
                -moz-transition: opacity 0.35s ease-in-out;
                -ms-transition: opacity 0.35s ease-in-out;
                -o-transition: opacity 0.35s ease-in-out;
                transition: opacity 0.35s ease-in-out;
              }
            }
          }
        }

        &.error {
          & .pricing__container__type__envio {
            &__image {
              opacity: 0;
              -webkit-transition: opacity 0.35s ease-in-out;
              -moz-transition: opacity 0.35s ease-in-out;
              -ms-transition: opacity 0.35s ease-in-out;
              -o-transition: opacity 0.35s ease-in-out;
              transition: opacity 0.35s ease-in-out;
            }

            &__time {
              margin-left: -40px;
              -webkit-transition: margin-left 0.35s ease-in-out;
              -moz-transition: margin-left 0.35s ease-in-out;
              -ms-transition: margin-left 0.35s ease-in-out;
              -o-transition: margin-left 0.35s ease-in-out;
              transition: margin-left 0.35s ease-in-out;

              &__text {
                opacity: 0;
                -webkit-transition: opacity 0.35s ease-in-out;
                -moz-transition: opacity 0.35s ease-in-out;
                -ms-transition: opacity 0.35s ease-in-out;
                -o-transition: opacity 0.35s ease-in-out;
                transition: opacity 0.35s ease-in-out;
              }
            }
          }
        }
      }
    }
  }

  &__buy {
    cursor: pointer;
    position: absolute;
    left: 195px;
    bottom: 250px;
    outline: none;
    width: 40%;
    border: 1px solid black;
    color: white;
    background-color: black;
    border-radius: 5px;
    padding: 8px 12px;
    font-size: 14px;
    line-height: 14px;
    -webkit-transition: opacity 0.35s ease-in-out, 0.35s ease-in-out border;
    -moz-transition: opacity 0.35s ease-in-out, 0.35s ease-in-out border;
    -ms-transition: opacity 0.35s ease-in-out, 0.35s ease-in-out border;
    -o-transition: opacity 0.35s ease-in-out, 0.35s ease-in-out border;
    transition: opacity 0.35s ease-in-out, 0.35s ease-in-out border;

    &.hidden {
      opacity: 0.25;
      pointer-events: none;
      -webkit-transition: opacity 0.35s ease-in-out, 0.35s ease-in-out border;
      -moz-transition: opacity 0.35s ease-in-out, 0.35s ease-in-out border;
      -ms-transition: opacity 0.35s ease-in-out, 0.35s ease-in-out border;
      -o-transition: opacity 0.35s ease-in-out, 0.35s ease-in-out border;
      transition: opacity 0.35s ease-in-out, 0.35s ease-in-out border;
    }
  }

  &__envio {
    display: none;

    &.error {
      & .pricing__envio {
        &__image {
          opacity: 0;
          -webkit-transition: opacity 0.35s ease-in-out;
          -moz-transition: opacity 0.35s ease-in-out;
          -ms-transition: opacity 0.35s ease-in-out;
          -o-transition: opacity 0.35s ease-in-out;
          transition: opacity 0.35s ease-in-out;
        }

        &__time {
          &__text {
            opacity: 0;
            -webkit-transition: opacity 0.35s ease-in-out;
            -moz-transition: opacity 0.35s ease-in-out;
            -ms-transition: opacity 0.35s ease-in-out;
            -o-transition: opacity 0.35s ease-in-out;
            transition: opacity 0.35s ease-in-out;
          }
        }
      }
    }
  }

  &.hidden {
    opacity: 0;
    pointer-events: none;
    -webkit-transition: opacity 0.35s ease-in-out,
      background-color 0.35s ease-in-out;
    -moz-transition: opacity 0.35s ease-in-out,
      background-color 0.35s ease-in-out;
    -ms-transition: opacity 0.35s ease-in-out,
      background-color 0.35s ease-in-out;
    -o-transition: opacity 0.35s ease-in-out, background-color 0.35s ease-in-out;
    transition: opacity 0.35s ease-in-out, background-color 0.35s ease-in-out;
  }

  &.noButton {
    .pricing__buy {
      display: none;
    }

    & .pricing__container {
      bottom: 260px;
    }

    &.hayMontaje {
      & .pricing__container {
        bottom: 285px;
      }
    }
  }

  @media screen and (max-width: 950px) and (min-height: 600px) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    position: absolute;
    bottom: 0px;
    left: revert;
    border-radius: 0%;
    width: 100%;
    height: 100px;
    padding: 0px 10px;
    margin-bottom: 0px;

    @media screen and (max-width: 350px) {
      padding: 0px 15px;
    }

    background-color: rgba(0, 0, 0);
    -webkit-transition: opacity 0.35s ease-in-out,
      margin-bottom 0.35s ease-in-out, background-color 0.35s ease-in-out;
    -moz-transition: opacity 0.35s ease-in-out, margin-bottom 0.35s ease-in-out,
      background-color 0.35s ease-in-out;
    -ms-transition: opacity 0.35s ease-in-out, margin-bottom 0.35s ease-in-out,
      background-color 0.35s ease-in-out;
    -o-transition: opacity 0.35s ease-in-out, margin-bottom 0.35s ease-in-out,
      background-color 0.35s ease-in-out;
    transition: opacity 0.35s ease-in-out, margin-bottom 0.35s ease-in-out,
      background-color 0.35s ease-in-out;

    &__container {
      position: revert;
      left: revert;
      color: white;
      height: 100px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;

      &__title {
      }

      &__value {
        height: 25px;

        &__loader {
          filter: invert(100%);
        }

        &__price {
          font-size: 25px;
          line-height: 25px;
        }
      }

      &__info {
        display: none;
      }

      &__type {
        display: none;

        &__producto {
          white-space: nowrap;
        }

        &__envio {
          display: none;
        }
      }
    }

    &__buy {
      display: block;
      top: 20px;
      right: 10px;
      border: 1px solid white;
      bottom: revert;
      left: revert;
      width: revert !important;
      -webkit-transition: opacity 0.35s ease-in-out, 0.35s ease-in-out border;
      -moz-transition: opacity 0.35s ease-in-out, 0.35s ease-in-out border;
      -ms-transition: opacity 0.35s ease-in-out, 0.35s ease-in-out border;
      -o-transition: opacity 0.35s ease-in-out, 0.35s ease-in-out border;
      transition: opacity 0.35s ease-in-out, 0.35s ease-in-out border;
    }

    &__envio {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      align-content: center;
      position: absolute;
      right: 10px;
      top: 60px;

      &__image {
        margin-right: 5px;
        height: 20px;
      }

      &__time {
        position: relative;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        align-content: center;

        &__loader {
          opacity: 0;
          position: absolute;
          height: 30px;
          filter: invert(100%);
          margin-left: -10px;
          -webkit-transition: opacity 0.35s ease-in-out,
            filter 0.35s ease-in-out;
          -moz-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
          -ms-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
          -o-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
          transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
        }

        &__text {
          opacity: 1;
          font-size: 12px;
          line-height: 12px;
          color: white;
          -webkit-transition: opacity 0.35s ease-in-out;
          -moz-transition: opacity 0.35s ease-in-out;
          -ms-transition: opacity 0.35s ease-in-out;
          -o-transition: opacity 0.35s ease-in-out;
          transition: opacity 0.35s ease-in-out;
        }
      }

      &.loading {
        & .pricing__envio {
          &__time {
            &__loader {
              opacity: 1;
              -webkit-transition: opacity 0.35s ease-in-out;
              -moz-transition: opacity 0.35s ease-in-out;
              -ms-transition: opacity 0.35s ease-in-out;
              -o-transition: opacity 0.35s ease-in-out;
              transition: opacity 0.35s ease-in-out;
            }

            &__text {
              opacity: 0;
              -webkit-transition: opacity 0.35s ease-in-out;
              -moz-transition: opacity 0.35s ease-in-out;
              -ms-transition: opacity 0.35s ease-in-out;
              -o-transition: opacity 0.35s ease-in-out;
              transition: opacity 0.35s ease-in-out;
            }
          }
        }
      }

      @media screen and (max-width: 350px) {
        margin-top: 18px;
      }
    }

    &.hidden {
      margin-bottom: -100px;
      -webkit-transition: opacity 0.35s ease-in-out,
        margin-bottom 0.35s ease-in-out, background-color 0.35s ease-in-out;
      -moz-transition: opacity 0.35s ease-in-out,
        margin-bottom 0.35s ease-in-out, background-color 0.35s ease-in-out;
      -ms-transition: opacity 0.35s ease-in-out, margin-bottom 0.35s ease-in-out,
        background-color 0.35s ease-in-out;
      -o-transition: opacity 0.35s ease-in-out, margin-bottom 0.35s ease-in-out,
        background-color 0.35s ease-in-out;
      transition: opacity 0.35s ease-in-out, margin-bottom 0.35s ease-in-out,
        background-color 0.35s ease-in-out;
    }
  }

  @media screen and (max-height: 600px) {
    bottom: -260px;
    left: -180px;

    &__container {
      left: 205px;
      bottom: 310px;
    }

    &__buy {
      left: 205px;
      bottom: 270px;
      width: revert !important;
      -webkit-transition: opacity 0.35s ease-in-out, 0.35s ease-in-out border;
      -moz-transition: opacity 0.35s ease-in-out, 0.35s ease-in-out border;
      -ms-transition: opacity 0.35s ease-in-out, 0.35s ease-in-out border;
      -o-transition: opacity 0.35s ease-in-out, 0.35s ease-in-out border;
      transition: opacity 0.35s ease-in-out, 0.35s ease-in-out border;

      @media screen and (max-width: 350px) {
        font-size: 12px;
      }
    }
  }
}
</style>
